export default "__VITE_ASSET__B3oP_Mdd__"